import classNames from 'classnames';

import lang from '../../lib/language';

import PackageInfo from '../../../package.json';
import commitSha from '../../commit-sha';
import config from '../../config';
import { useIsMobile } from '../../hooks';
import { startMockedMode } from '../../util/helpers';
import ClickableDiv from '../ClickableDiv/ClickableDiv';

import styles from './AppVersion.module.scss';

const isNotProdEnv = config.currentEnv !== 'prod';

const AppVersion = () => {
  const { isMobile } = useIsMobile();

  return (
    <ClickableDiv
      className={isMobile
        ? styles.wrapperAppVersionMob
        : classNames(
          styles.wrapperAppVersion,
          styles.wrapperAppVersionWeb,
        )}
      onClick={startMockedMode}
    >
      <p className={styles.appVersionText}>
        {`${lang.mobileProfileVersion()} ${PackageInfo.version}`}
        {isNotProdEnv && (
        <span>
          (
          {config.currentEnv}
          )
        </span>
        )}
      </p>
      {isNotProdEnv && (
      <p className={styles.appVersionBuildText}>
        {`${lang.mobileProfileBuild()} ${commitSha}`}
      </p>
      )}
    </ClickableDiv>
  );
};

export default AppVersion;
